import type { ItemMetaData } from '@mimir/common/dto/fieldValue';
import type { ClientItem } from '@mimir/common/dto/searchResultHit';
import { replaceIdWithFieldIdForSchemasAndFillDefaultValues } from '@mimir/common/mdf/MetaDataForm';
import { getFieldDefinitionsForMetadata } from '@mimir/common/mdf/subtype';
import { mdfState } from '@mimir/web/globals/mdfState';

/**
 * Send a message to parent frame. Used in Vimond IO export workflow.
 * @param item The item to pick data from
 */
export const sendSelectedEvent = async (item: Partial<ClientItem> | null) => {
  let message;
  if (item === null) {
    message = {
      action: 'deselected'
    };
  } else if (!item.metadata) {
    message = {
      action: 'selected',
      payload: {
        id: item.id,
      }
    };
  } else {
    message = {
      action: 'selected',
      payload: {
        id: item.id,
        metadata: replaceIds(item.metadata)
      }
    };
  }

  window.parent.postMessage(message, '*');
};

/**
 * Return a copy with all GUIDs replaced with their corresponding field id
 */
export const replaceIds = (metadata: ItemMetaData): ItemMetaData => {
  const { fieldMap } = getFieldDefinitionsForMetadata(metadata, mdfState.state.mdfs);
  const clone = replaceIdWithFieldIdForSchemasAndFillDefaultValues(metadata, Object.values(fieldMap));
  return clone;
};
